import { Card, Modal } from '@material-ui/core';
import styled from 'styled-components';
import Button from '~/components/Button';
import Colors from '~/styles/colors';

export const StyledModal = styled(Modal)`
  position: absolute;
`;

export const Content = styled(Card)`
  width: 560px;
  min-height: 200px;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  padding: 24px;
`;

export const Title = styled.h2`
  margin: 0 0 20px 0;
  font-size: 18px;
  font-weight: bold;
`;

export const FieldsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const ButtonContainer = styled.div`
  justify-content: flex-end;
  display: flex;
  margin-top: 24px;
  gap: 8px;
`;

export const StyledButton = styled(Button)`
  color: ${Colors.secondary};
  background-color: ${Colors.primary};
  width: 100px;
  height: 30px;
`;
